"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionResult = exports.toTxResult = void 0;
var future_1 = require("@celo/base/lib/future");
var debug_1 = __importDefault(require("debug"));
var debug = (0, debug_1.default)('connection:tx:result');
/**
 * Transforms a `PromiEvent` to a `TransactionResult`.
 */
function toTxResult(pe) {
    return new TransactionResult(pe);
}
exports.toTxResult = toTxResult;
/**
 * Replacement interface for web3's `PromiEvent`. Instead of emiting events
 * to signal different stages, eveything is exposed as a promise. Which ends
 * up being nicer when doing promise/async based programming.
 */
var TransactionResult = /** @class */ (function () {
    function TransactionResult(pe) {
        var _this = this;
        this.hashFuture = new future_1.Future();
        this.receiptFuture = new future_1.Future();
        pe.on('transactionHash', function (hash) {
            debug('hash: %s', hash);
            _this.hashFuture.resolve(hash);
        })
            .on('receipt', function (receipt) {
            debug('receipt: %O', receipt);
            _this.receiptFuture.resolve(receipt);
        })
            .on('error', (function (error, receipt) {
            if (!receipt) {
                debug('send-error: %o', error);
                _this.hashFuture.reject(error);
            }
            else {
                debug('mining-error: %o, %O', error, receipt);
            }
            _this.receiptFuture.reject(error);
        }));
    }
    /** Get (& wait for) transaction hash */
    TransactionResult.prototype.getHash = function () {
        var _this = this;
        return this.hashFuture.wait().catch(function (err) {
            // if hashFuture fails => receiptFuture also fails
            // we wait for it here; so not UnhandlePromise error occurrs
            _this.receiptFuture.wait().catch(function () {
                // ignore
            });
            throw err;
        });
    };
    /** Get (& wait for) transaction receipt */
    TransactionResult.prototype.waitReceipt = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Make sure `getHash()` promise is consumed
                    return [4 /*yield*/, this.getHash()];
                    case 1:
                        // Make sure `getHash()` promise is consumed
                        _a.sent();
                        return [2 /*return*/, this.receiptFuture.wait()];
                }
            });
        });
    };
    return TransactionResult;
}());
exports.TransactionResult = TransactionResult;
//# sourceMappingURL=tx-result.js.map